
import { Component, Vue, Prop } from "vue-property-decorator";

import subscription_routes from "@/api/routes/subscriptions";

interface ISubscriptionData {
  learning_time: number;
}

@Component({
  name: "CSubscriptionUnitLearningTime"
})
export default class CSubscriptionUnitLearningTime extends Vue {
  @Prop({ required: true }) private subscription_unit_id!: string;
  @Prop({ required: true }) private is_current_user_subscription!: boolean;

  private interval: NodeJS.Timeout | null = null;

  protected async created() {
    await this.updateSubscription({ learning_time: 1 });
  }

  protected mounted() {
    this.interval = setInterval(async () => {
      await this.updateSubscription({ learning_time: 5 });
    }, 5000);
  }

  public clearInterval() {
    if (this.interval) {
      clearInterval(this.interval);

      this.interval = null;
    }
  }

  private async updateSubscription(data: ISubscriptionData) {
    if (!this.is_current_user_subscription) {
      return;
    }

    return this.$api
      .put(
        subscription_routes.subscription_unit(this.subscription_unit_id),
        data
      )
      .catch(({ response: res }) => {
        this.clearInterval();

        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  protected beforeDestroy() {
    this.clearInterval();
  }
}
